import React, { useState } from 'react';
import {
  PageShell,
  PageHeader,
  SearchInput,
  SegmentedFilter,
} from 'components/v3';
import DiscoverContent from './components/DiscoverContent';
import HowToContent from './components/HowToContent';
import VideoModal from './components/VideoModal';
import { useGetLearningHubSettings } from './gql';
import { ContentCard, ContentHeader, SearchWrapper } from './StyledComponents';

const MODE_OPTIONS = [
  { key: 'discover', label: 'Ideas & Tips' },
  { key: 'howto', label: 'How To Do It' },
];

const LearningHub = () => {
  const [mode, setMode] = useState('discover');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedVideo, setSelectedVideo] = useState(null);
  // True when the active section has no content AND no search/topic filter is
  // applied — used to hide the now-useless search + filter controls.
  const [sectionEmpty, setSectionEmpty] = useState(false);

  const { settings } = useGetLearningHubSettings();

  return (
    <PageShell>
      <PageHeader icon="graduation-cap" title="Learning Hub" />

      <ContentCard>
        <ContentHeader>
          <SegmentedFilter
            value={mode}
            onChange={setMode}
            options={MODE_OPTIONS}
          />
          {!sectionEmpty && (
            <SearchWrapper>
              <SearchInput
                onChange={setSearchQuery}
                placeholder="Search videos..."
                debounce={300}
              />
            </SearchWrapper>
          )}
        </ContentHeader>

        {mode === 'discover' ? (
          <DiscoverContent
            searchQuery={searchQuery}
            onPlayVideo={setSelectedVideo}
            onEmptyChange={setSectionEmpty}
          />
        ) : (
          <HowToContent
            searchQuery={searchQuery}
            onPlayVideo={setSelectedVideo}
            onEmptyChange={setSectionEmpty}
          />
        )}
      </ContentCard>

      <VideoModal
        video={selectedVideo}
        onClose={() => setSelectedVideo(null)}
        mode={mode}
        helpBaseUrl={settings?.help_base_url}
      />
    </PageShell>
  );
};

export default LearningHub;
